export const monthlyLimitLabel = (limit: number | null) =>
  limit === null || limit >= 999 ? 'Unlimited' : `${limit}/month`;
